/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Accessibility_LinkInputs */

const en_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility`)
};

const de_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barrierefreiheit`)
};

const fr_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibilite`)
};

const es_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesibilidad`)
};

const it_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibilita`)
};

const nl_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegankelijkheid`)
};

const pl_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostepnosc`)
};

const fi_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutettavuus`)
};

const da_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilgaengelighed`)
};

const sv_landing_accessibility_link = /** @type {(inputs: Landing_Accessibility_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tillgaenglighet`)
};

/**
* | output |
* | --- |
* | "Accessibility" |
*
* @param {Landing_Accessibility_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_accessibility_link = /** @type {((inputs?: Landing_Accessibility_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Accessibility_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_accessibility_link(inputs)
	if (locale === "fr") return fr_landing_accessibility_link(inputs)
	if (locale === "es") return es_landing_accessibility_link(inputs)
	if (locale === "it") return it_landing_accessibility_link(inputs)
	if (locale === "nl") return nl_landing_accessibility_link(inputs)
	if (locale === "pl") return pl_landing_accessibility_link(inputs)
	if (locale === "fi") return fi_landing_accessibility_link(inputs)
	if (locale === "da") return da_landing_accessibility_link(inputs)
	if (locale === "sv") return sv_landing_accessibility_link(inputs)
	return en_landing_accessibility_link(inputs)
});